/* Printed Ambition — theme.js
   Vanilla JS. Mobile menu, sticky header, announcement dismiss, cart count refresh. */

(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const menuClose = document.querySelector('[data-menu-close]');
  const menuBackdrop = document.querySelector('[data-mobile-menu-backdrop]');

  function openMenu() {
    if (!mobileMenu) return;
    mobileMenu.setAttribute('aria-hidden', 'false');
    if (menuBackdrop) menuBackdrop.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    if (!mobileMenu) return;
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (menuBackdrop) menuBackdrop.removeAttribute('data-open');
    document.body.style.overflow = '';
  }
  menuToggle && menuToggle.addEventListener('click', openMenu);
  menuClose && menuClose.addEventListener('click', closeMenu);
  menuBackdrop && menuBackdrop.addEventListener('click', closeMenu);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeMenu(); });

  /* ---------- FAQ: auto-open the first item when the FAQ scrolls into view ---------- */
  const firstFaqItem = document.querySelector('[data-faq-item]');
  if (firstFaqItem && 'IntersectionObserver' in window) {
    const faqObs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !firstFaqItem.open) {
          firstFaqItem.open = true;
          faqObs.disconnect();
        }
      });
    }, { threshold: 0.4 });
    faqObs.observe(firstFaqItem);
  }

  /* ---------- Sticky header shadow on scroll ---------- */
  const header = document.querySelector('[data-header]');
  if (header) {
    let last = 0;
    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('header--scrolled', y > 8);
      last = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Announcement bar dismiss (sessionStorage) ---------- */
  const announcement = document.querySelector('[data-announcement]');
  if (announcement) {
    const dismissed = sessionStorage.getItem('pa_announcement_dismissed');
    if (dismissed === '1') announcement.style.display = 'none';
    const dismissBtn = announcement.querySelector('[data-announcement-dismiss]');
    dismissBtn && dismissBtn.addEventListener('click', () => {
      announcement.style.display = 'none';
      sessionStorage.setItem('pa_announcement_dismissed', '1');
    });
  }

  /* ---------- How It Works step interactions ----------
     Desktop: cursor-follow gradient via CSS vars.
     Mobile: tap toggles .is-tapped for the same hover treatment. */
  const steps = document.querySelectorAll('.how-it-works__step');
  steps.forEach((step) => {
    step.addEventListener('mousemove', (e) => {
      const r = step.getBoundingClientRect();
      step.style.setProperty('--mx', `${((e.clientX - r.left) / r.width) * 100}%`);
      step.style.setProperty('--my', `${((e.clientY - r.top) / r.height) * 100}%`);
    });
    step.addEventListener('mouseleave', () => {
      step.style.removeProperty('--mx');
      step.style.removeProperty('--my');
    });
    step.addEventListener('touchstart', () => {
      steps.forEach((s) => s.classList.remove('is-tapped'));
      step.classList.add('is-tapped');
    }, { passive: true });
  });

  /* ---------- Cash-coin floaters — fade in/out as user scrolls past ---------- */
  const floaters = document.querySelectorAll('[data-floater]');
  if (floaters.length && 'IntersectionObserver' in window) {
    const floatObs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('is-visible', entry.isIntersecting);
      });
    }, { threshold: 0.1, rootMargin: '-12% 0px -12% 0px' });
    floaters.forEach((f) => floatObs.observe(f));
  } else {
    floaters.forEach((f) => f.classList.add('is-visible'));
  }

  /* ---------- Scroll reveal — slides/fades elements in as they enter the viewport ---------- */
  const reveals = document.querySelectorAll('[data-reveal]');
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reveals.length && 'IntersectionObserver' in window && !reduceMotion) {
    const revealObs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach((el) => revealObs.observe(el));
  } else if (reveals.length) {
    reveals.forEach((el) => el.classList.add('is-revealed'));
  }

  /* ---------- Cart count refresh ---------- */
  async function refreshCartCount() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.toggleAttribute('hidden', cart.item_count === 0);
      });
    } catch (err) { /* silent */ }
  }
  document.addEventListener('cart:updated', refreshCartCount);
  refreshCartCount();
})();
